import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContactsComponent } from '../_shared/component/contacts/contacts.component';
import { SharedModule } from '../_shared/shared.module';
import { NavigationModule } from '../navigation/navigation.module';
import { CampaignsRoutingModule } from './campaigns-routing.module';
import { AgentMarketingCampaignInfoComponent } from './component/agent-marketing-campaign-info/agent-marketing-campaign-info.component';
import { AgentMarketingCampaignsComponent } from './component/agent-marketing-campaigns/agent-marketing-campaigns.component';
import { CampaignAutomationDialogComponent } from './component/campaign-automation-dialog/campaign-automation-dialog.component';
import { CampaignInfoComponent } from './component/campaign-info/campaign-info.component';
import { CampaignsComponent } from './component/campaigns/campaigns.component';
import { CreateCampaignSheetComponent } from './component/create-campaign-sheet/create-campaign-sheet.component';
import { StatusCampaignSheetComponent } from './component/status-campaign-sheet/status-campaign-sheet.component';

@NgModule({
  declarations: [
    CampaignsComponent,
    ContactsComponent,
    CreateCampaignSheetComponent,
    CampaignAutomationDialogComponent,
    CampaignInfoComponent,
    StatusCampaignSheetComponent,
    AgentMarketingCampaignsComponent,
    AgentMarketingCampaignInfoComponent,
  ],
  imports: [
    CampaignsRoutingModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatTableModule,
    MatTooltipModule,
    NavigationModule,
    NgbModule,
    ReactiveFormsModule,
    SharedModule,
    MatExpansionModule,
    MatRadioModule,

  ],
  exports: [
    CampaignsComponent, CreateCampaignSheetComponent
  ]
})
export class CampaignsModule { }
